/** The global count of integrated apps on Zapier */
export const GLOBAL_APP_COUNT: string = '3,000';
